import fetch from "./httpFetch.js";
import Cookies from "js-cookie";
const modelName = "/openplat-service-server/v/service";
const systemModel = "/openplat-service-server/v/system";
const subscriptionUrl = "/openplat-subscription-server/v";
import Axios from 'axios';

/**
 * 获取用户认证状态
 * @param {*} data 
 * @returns 
 */
export function getUserPersonalAccountAuth(data) {
  return fetch.get("/openplat-user-server/v/getUserPersonalAccountAuth", data);
}
/**
 * 获取有奖调研的开始时间，结束时间，跳转地址
 */
export function config(code = "") {
  return fetch.get(systemModel + "/config?plugin_code=" + (code ? code : 'portal_pop'));
}
/***收藏***/
export function unVote(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post(modelName + "/unVote", data);
}
export function vote(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post("/openplat-service-server/v/service/vote", data);
}
export function isVote(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post("/openplat-service-server/v/service/isVote", data);
}
//服务详情页-服务详情信息
export function detail(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post("/openplat-service-server/v/service/detail", data);
}
//服务详情页-适用范围
export function getServiceOpenLevel(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post("/openplat-service-server/v/service/getServiceOpenLevel", data);
}

export function getAliServiceLogin(data) {
  return fetch.post(
    "/openplat-service-server/v/service/getAliServiceLoginUrl",
    data,
    {
      errorHandler: true
    }
  );
}
export function getApiDoc(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post("/openplat-service-server/v/service/getApiDoc", data);
}
export function getSysAttribute() {
  let data = {
    attribute_name: "message_service_evaluate"
  };
  return fetch.post("/openplat-service-server/v/system/getSysAttribute", data);
}
export function getServiceCompany(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post(
    "/openplat-service-server/v/service/getServiceCompany",
    data
  );
}
export function queryBlogListByService(sid) {
  let data = {
    content: sid
  };
  return fetch.post(
    "/openplat-service-server/v/system/queryBlogListByService",
    data
  );
}
export function queryServiceList(sid, id) {
  let data = {
    classify_id: sid,
    exclude_service_ids: [id]
  };
  return fetch.post(
    "/openplat-service-server/v/service/queryServiceListPage",
    data
  );
}
export function queryServiceEvaluateListPage(sid, page_num) {
  let data = {
    service_id: sid,
    page_num: page_num,
    page_size: 5
  };
  return fetch.post(
    "/openplat-service-server/v/service/queryServiceEvaluateListPage",
    data
  );
}
export function addServiceEvaluation(sid, score, content) {
  let data = {
    service_id: sid,
    score: score,
    content: content
  };
  return fetch.post(
    "/openplat-service-server/v/service/addServiceEvaluation",
    data
  );
}

// TODO:完善个人信息
export function queryServiceContractExtAttr(sid) {
  let data = {
    service_id: sid
  };
  return fetch.post(modelName + "/queryServiceContractExtAttr", data);
}
export function saveServiceContractExtAttr(sid, list) {
  let data = {
    service_id: sid,
    list: list
  };
  return fetch.post(modelName + "/saveServiceContractExtAttr", data);
}
export function getUserBaseInfo() {
  return fetch.post("/openplat-user-server/v/getUserBaseInfo");
}
export function perfectUserBaseInfo(params) {
  return fetch.post("/openplat-user-server/v/perfectUserBaseInfo", params);
}
export function getChargeInfo(sno) {
  let data = {
    serial_no: sno
  };
  return fetch.post(modelName + "/getChargeInfo", data);
}
export function getchargeUserCanBuyNum(sno) {
  let data = {
    serial_no: sno
  };
  return fetch.post(modelName + "/getchargeUserCanBuyNum", data);
}
export function checkUserBuyPermissions(params) {
  return fetch.post(modelName + "/checkUserBuyPermissions", params,{
    errorHandler:true
});
}
export function isActivity() {
  return fetch.post("/openplat-service-server/v/system/isActivity");
}

//服务申请接口
export function queryDictItem(dict_code) {
  let data = {
    dict_entry_code: dict_code
  };
  return fetch.post("/openplat-service-server/v/system/queryDictItem", data);
}
/**
 * 订单/申请单确认页-获取用户的应用信息
 * @param {*} environment 
 * @returns 
 */
export function comboxList(environment,account_id) {
  let data = {
    environment: environment,
    account_id:account_id
  };
  return fetch.post("/openplat-service-server/v/client/comboxList", data);
}
export function fsearch(enterprise_name) {
  let data = {
    enterprise_name: enterprise_name
  };
  return fetch.post("/openplat-service-server/v/open/enterprise/fsearch", data);
}
/**
 * 订单/申请单确认页-添加应用
 * @param {*} data 
 * @returns 
 */
export function addClient(data) {
  return fetch.post("/openplat-service-server/v/client/add", data);
}
export function applyService(data) {
  return fetch.post("/openplat-service-server/v/service/applyService", data);
}
//同意协议勾选
export function addServiceAgreementRecord(data) {
  return fetch.post("/openplat-service-server/v/service/addServiceAgreementRecord", data);
}
//获取协议勾选记录
export function getServiceAgreementRecord(data) {
  return fetch.post("/openplat-service-server/v/service/getServiceAgreementRecord", data);
}

/************公用接口Begin*************/
//埋点接口
// 老版本埋点，被gio替代
// export function addUserAnalysis(params) {
//   return fetch.post(
//     `/openplat-user-server/v/userAnalysis/addUserAnalysis`,
//     params
//   );
// }


//获取证书服务的允许的业务列表
export function queryCertificateBusiness(data) {
  return fetch.post("/openplat-service-server/v/certificate/queryCertificateBusiness", data);
}
//获取证书服务的市场列表
export function queryCertificateMarket(data) {
  return fetch.post("/openplat-service-server/v/certificate/queryCertificateMarket", data);
}
//证书名称校验
export function judgeCertificateName(data) {
  return fetch.post("/openplat-service-server/v/certificate/judgeCertificateName", data, {
    errorHandler: true
  });
}


/**是否需要签署协议 */
export function isSignUplusAgreement (data) {
  return fetch.get("/openplat-auth-server/v/uplus/isSignUplusAgreement", data)
}
/**
 * 签署协议
 * @param {*} data 
 * @returns 
 */
export function signUplusAgreement (data) {
  return fetch.post("/openplat-auth-server/v/uplus/signUplusAgreement", data)
}


/**
 * 服务详情页-获取优惠券
 * @param {*} data 
 * @returns 
 */
export function couponList(data) {
  return fetch.post("/openplat-service-server/v/service/couponList", data);
}
/**
 * 订单详情页-获取当前套餐可用的优惠券
 * @param {*} data 
 * @returns 
 */
export function queryCouponByCharge(data) {
  return fetch.post("/openplat-service-server/v/queryCouponByCharge", data);
}

/**
 * 添加订单
 * @param {*} data 
 * @returns 
 */
export function addOrderInner(data) {
  return fetch.post("/openplat-order-server/v/order/addOrderInner", data);
}

/**
 * 订单详情
 * @param {*} data 
 * @returns 
 */
export function queryMyOrderDetailInner(data) {
  return fetch.post("/openplat-order-server/v/order/queryMyOrderDetailInner", data);
}
/**
 * 获取支付方式
 * @param {*} data 
 * @returns 
 */
export function getOrderPaymentType(data) {
  return fetch.post("/openplat-order-server/v/order/getOrderPaymentType", data);
}
/**
 * 线下支付-填写回执信息
 * @param {*} data 
 * @returns 
 */
export function submitOfflineReceipt(data) {
  return fetch.post("/openplat-order-server/v/order/submitOfflineReceipt", data);
}
/**
 * 订单支付
 */
export function payOrderInner(data) {
  return fetch.post("/openplat-order-server/v/order/payOrderInner", data);
}
/**
 * 支付结果查询
 */
export function getPaymentResultInner(data) {
  return fetch.post("/openplat-order-server/v/order/getPaymentResultInner", data);
}
/**
 * 线下支付-查询回执信息
 * @param {*} data 
 * @returns 
 */
export function queryOfflineReceipt(data) {
  return fetch.post("/openplat-order-server/v/order/queryOfflineReceipt", data);
}

function getObjectURL (file) {
  let url = null
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file)
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    try {
      url = window.webkitURL.createObjectURL(file)
    } catch (error) { }
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    try {
      url = window.URL.createObjectURL(file)
    } catch (error) { }
  }
  return url
}
/**服务详情页-合同预览 */
export function getViewContractTempByService(service_id) {
  // return fetch.get("/openplat-service-server/v/getViewContractTempByService", {params});
  return new Promise((resolve) => {
    Axios.get(`/openplat-gateway/openplat/openplat-service-server/v/getViewContractTempByService?service_id=${service_id}`, {responseType: 'blob'}).then(res => {
      // debugger
      if(res.status==200){
        let url = getObjectURL(res.data)
        resolve(url)
      }else{
        console.error('接口异常')
      }
      
    })
  })
}

/**获取当前用户的企业账号信息 */
export function getEnterpriseAccount (data) {
  return fetch.get("/openplat-user-server/v/getEnterpriseAccount", data)
}

//身份校验
export function identityCheck(params) {
	return fetch.get('/openplat-auth-server/v/identity_check',{params} )
}
//获取登录用户归属
export function getUserAgent(params) {
	return fetch.post(modelName+'/getUserAgent', params)
}



// 购买产品套餐校验
export function checkPurchasePermissions(params) {
	return fetch.post(`${subscriptionUrl}/checkPurchasePermissions`,params)
}
// 购买产品套餐校验不通过-用户认证状态查询
export function checkUserAuthForServicePackage(params) {
	return fetch.post(`${subscriptionUrl}/checkUserAuthForServicePackage`,params)
}
// 购买产品套餐校验不通过-获取账号信息
export function getUserBaseInfoForSuscribe(params) {
	return fetch.get(`${subscriptionUrl}/getUserBaseInfo`,params)
}
// 购买产品套餐校验不通过-补充账号信息
export function perfectUserBaseInfoForSuscribe(params) {
	return fetch.post(`${subscriptionUrl}/perfectUserBaseInfo`,params)
}
// 购买产品套餐校验不通过-补充账号信息--搜索公司
export function fsearchForSuscribe(params) {
	return fetch.post(`${openplatUrl}/open/enterprise/fsearch`,params)
}


// WEBPACK FOOTER //
// ./src/gtn/api/service.js